var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-flex',{attrs:{"basic":1}},[_c('ui-cell',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('ui-cell',[_c('div',{staticClass:"content"},[_c('span',[_vm._v(_vm._s(_vm.value))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }